module.exports = __webpack_public_path__ + "img/about-values-passion.jpg?88558a46b536f410f094179c52e3026f";